export default {"src":"/_next/static/media/PrepareForLaunch.f6a02f20.svg","height":66,"width":76,"blurWidth":0,"blurHeight":0};